/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForReservedInstances extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForReservedInstances.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForReservedInstances>): ProgressDetailsForReservedInstances {
        let obj = Object.assign(new ProgressDetailsForReservedInstances(), model);
        ProgressDetailsForReservedInstances.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForReservedInstances>): ProgressDetailsForReservedInstances {
        if (!model) return null;
        return ProgressDetailsForReservedInstances.newInstance(<ProgressDetailsForReservedInstances> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForReservedInstances) {
        if (!obj) return;

        models.ProgressDetailsForReservedInstances.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForReservedInstances): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForReservedInstances.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * If set, back fill was completed
     */
    back_filled: boolean;

}
